var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "histo", staticStyle: { height: "100%" } },
    [
      _c(
        "v-card",
        { attrs: { flat: "", height: _vm.chatHeight } },
        [
          _vm.navigation
            ? _c(
                "v-navigation-drawer",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.listChats,
                      expression: "listChats"
                    }
                  ],
                  staticClass: "contentListeHistoChats",
                  staticStyle: { "z-index": "1" },
                  attrs: {
                    "enable-resize-watcher": "",
                    width: "320",
                    light: "",
                    absolute: "",
                    persistent: "",
                    clipped: "",
                    "hide-overlay": ""
                  },
                  model: {
                    value: _vm.listChats,
                    callback: function($$v) {
                      _vm.listChats = $$v
                    },
                    expression: "listChats"
                  }
                },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "white",
                      attrs: { flat: "", dense: "", extended: "" }
                    },
                    [
                      _c("v-toolbar-title", [
                        _vm._v(_vm._s(_vm.$t("botHistory")))
                      ]),
                      _vm._v(" "),
                      _vm.visiteurs.length
                        ? _c(
                            "div",
                            { attrs: { slot: "extension" }, slot: "extension" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$tc("visitors", _vm.visiteurs.length, {
                                      count: _vm.visiteurs.length
                                    })
                                  ) +
                                  "\n            "
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    slot: "activator",
                                    color: "primary",
                                    loading: _vm.loadingExportChats,
                                    disabled:
                                      !_vm.visiteurs.length ||
                                      _vm.loadingExportChats,
                                    flat: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.exportAllChats({ view: false })
                                    }
                                  },
                                  slot: "activator"
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("statexport")) +
                                      "\n              "
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "primary", right: "" } },
                                    [_vm._v("visibility")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "subheading",
                              attrs: { slot: "extension" },
                              slot: "extension"
                            },
                            [_vm._v(_vm._s(_vm._f("cap")(_vm.$tc("chats", 0))))]
                          )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "listeChatsVisiteurs" },
                    [
                      _vm.loadingHisto
                        ? _c(
                            "v-card",
                            [
                              _c(
                                "v-card-text",
                                { staticClass: "text-xs-center pt-5" },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "primary--text",
                                    attrs: { indeterminate: "" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "v-list",
                            { attrs: { "two-line": "", dense: "" } },
                            _vm._l(_vm.chatsSorted, function(visiteur) {
                              return _c(
                                "v-list-group",
                                {
                                  key: visiteur.visId,
                                  attrs: {
                                    value: visiteur.visId == _vm.visitorSelected
                                  }
                                },
                                [
                                  _c(
                                    "v-list-tile",
                                    {
                                      attrs: { slot: "activator", ripple: "" },
                                      on: { click: function($event) {} },
                                      slot: "activator"
                                    },
                                    [
                                      _c(
                                        "v-list-tile-action",
                                        [
                                          _c("wz-avatar", {
                                            attrs: {
                                              username: "#" + visiteur.visId,
                                              size: "35px"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c("v-list-tile-title", [
                                            _vm._v(_vm._s(visiteur.visId))
                                          ]),
                                          _vm._v(" "),
                                          _c("v-list-tile-sub-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$tc(
                                                  "chats",
                                                  visiteur.chats.length,
                                                  {
                                                    count: visiteur.chats.length
                                                  }
                                                )
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._l(visiteur.chats, function(chat) {
                                    return _c(
                                      "v-list-tile",
                                      {
                                        key: chat.id,
                                        class: {
                                          "grey lighten-2":
                                            chat.id == _vm.chatId
                                        },
                                        attrs: { ripple: "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.showChat(chat.id)
                                          }
                                        }
                                      },
                                      [
                                        _c("wz-avatar-double", {
                                          attrs: {
                                            avatars: [
                                              { id: visiteur.visId },
                                              {
                                                id: chat.last.agentId,
                                                username: chat.last.agentName
                                              }
                                            ]
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-content",
                                          [
                                            _c("v-list-tile-title", [
                                              _vm._v(
                                                _vm._s(
                                                  chat.last.auteur == "Visiteur"
                                                    ? visiteur.visId
                                                    : chat.last.agentName
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("v-list-tile-sub-title", [
                                              _vm._v(_vm._s(chat.last.text))
                                            ])
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-list-tile-action", [
                                          _vm._v(_vm._s(chat.last.date))
                                        ])
                                      ],
                                      1
                                    )
                                  })
                                ],
                                2
                              )
                            }),
                            1
                          )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { "justify-center": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c("v-pagination", {
                                    attrs: {
                                      length: _vm.calculTotalagination,
                                      circle: "",
                                      disabled: _vm.numChatsTotal <= 100
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.paginationInput(
                                          _vm.pagination
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.pagination,
                                      callback: function($$v) {
                                        _vm.pagination = $$v
                                      },
                                      expression: "pagination"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.toolbar
            ? _c(
                "v-toolbar",
                {
                  staticClass: "primary",
                  class: { "histo__navigation--opened": _vm.listChats },
                  attrs: { dark: "", dense: "", extended: "" }
                },
                [
                  _vm.navigation
                    ? _c("v-toolbar-side-icon", {
                        nativeOn: {
                          click: function($event) {
                            _vm.listChats = !_vm.listChats
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.chatId
                    ? _c("v-toolbar-title", { staticClass: "white--text" }, [
                        _vm._v("#" + _vm._s(_vm.visitorSelected))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.chatSelected
                    ? _c(
                        "div",
                        {
                          staticClass: "white--text subheading",
                          attrs: { slot: "extension" },
                          slot: "extension"
                        },
                        [
                          false
                            ? _c("v-tooltip", { attrs: { right: "" } }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "mr-3",
                                    attrs: { slot: "activator" },
                                    slot: "activator"
                                  },
                                  [
                                    _c("v-icon", { attrs: { dark: "" } }, [
                                      _vm._v("access_time")
                                    ]),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.chatSelected.duration) +
                                        "\n            "
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Durée totale")])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          false
                            ? _c("v-tooltip", { attrs: { right: "" } }, [
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "activator" },
                                    slot: "activator"
                                  },
                                  [
                                    _c("v-icon", { attrs: { dark: "" } }, [
                                      _vm._v("timer")
                                    ]),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.chatSelected.averageResponse
                                        ) +
                                        "\n            "
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("chatsAverageResponse")))
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "ml-2" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.chatSelected.messages.length) +
                                  "\n            "
                              ),
                              _c("v-icon", { attrs: { dark: "", right: "" } }, [
                                _vm._v("chat_bubble_outline")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.chatSelected.closed
                            ? _c(
                                "span",
                                { staticClass: "ml-2" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("closing")) +
                                      " : " +
                                      _vm._s(_vm.chatSelected.closed) +
                                      "\n            "
                                  ),
                                  _c(
                                    "v-icon",
                                    { attrs: { dark: "", right: "" } },
                                    [_vm._v("offline_pin")]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _vm.chatSelected
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "icon",
                            loading: _vm.loadingExportChat,
                            disabled: _vm.loadingExportChat
                          },
                          on: {
                            click: function($event) {
                              return _vm.exportChat()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("file_download")])],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "main",
            {
              directives: [{ name: "bar", rawName: "v-bar" }],
              ref: "contentChat",
              class: {
                "histo__navigation--opened vb": _vm.listChats,
                "histo__main--toolbar vb": _vm.toolbar,
                "histo__main--no-toolbar vb": !_vm.toolbar
              },
              staticStyle: { height: "100%" },
              attrs: { id: "contentChat" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "histo__main--scroll",
                  attrs: { "grid-list-sm": "", fluid: "" }
                },
                [
                  _vm.loading
                    ? _c(
                        "v-card",
                        { attrs: { height: _vm.chatHeight } },
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "text-xs-center pt-5" },
                            [
                              _c("v-progress-circular", {
                                staticClass: "primary--text",
                                attrs: { indeterminate: "" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm.chatSelected
                    ? _c(
                        "div",
                        { attrs: { height: "100%" } },
                        [
                          _c(
                            "transition",
                            {
                              attrs: {
                                name: "slide-x-reverse-transition",
                                mode: "out-in"
                              }
                            },
                            [
                              _c(
                                "v-layout",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { row: "", wrap: "" }
                                },
                                [
                                  _vm.msg.anotherDay
                                    ? _c(
                                        "v-flex",
                                        {
                                          key: _vm.msg.date,
                                          staticClass: "text-xs-center sticky",
                                          attrs: { xs12: "" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "dateMessageChat",
                                              attrs: { secondary: "" }
                                            },
                                            [_vm._v(_vm._s(_vm.msg.anotherDay))]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(_vm.chatSelected.messages, function(
                                    msg,
                                    i
                                  ) {
                                    return _c(
                                      "v-flex",
                                      { key: i, attrs: { xs12: "" } },
                                      [
                                        msg.auteur == "Agent"
                                          ? _c(
                                              "v-layout",
                                              { attrs: { row: "" } },
                                              [
                                                _c(
                                                  "v-flex",
                                                  {
                                                    staticClass:
                                                      "text-xs-right",
                                                    attrs: { xs2: "" }
                                                  },
                                                  [
                                                    _c("wz-avatar", {
                                                      attrs: {
                                                        username: msg.agentName,
                                                        src:
                                                          _vm.domaine +
                                                          "/public/media/user/small/" +
                                                          msg.agentId +
                                                          "_avatar.jpg",
                                                        size: "35px"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs10: "" } },
                                                  [
                                                    _c(
                                                      "v-card",
                                                      {
                                                        class: [
                                                          "white--text",
                                                          "histo__bubble",
                                                          "histo__bubble--agent",
                                                          _vm.colorChatAgent
                                                        ]
                                                      },
                                                      [
                                                        _c(
                                                          "v-card-text",
                                                          {
                                                            staticClass: "pa-1"
                                                          },
                                                          [
                                                            false
                                                              ? _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "corner corner--agent",
                                                                    attrs: {
                                                                      color:
                                                                        _vm.colorChatAgent,
                                                                      unselectable:
                                                                        "on",
                                                                      onselectstart:
                                                                        "return false;",
                                                                      onmousedown:
                                                                        "return false;"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "arrow_drop_down"
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c("div", [
                                                              msg.text
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        msg.text
                                                                      )
                                                                    )
                                                                  ])
                                                                : _c("img", {
                                                                    attrs: {
                                                                      src:
                                                                        msg.attachment,
                                                                      alt:
                                                                        "Image indisponible"
                                                                    }
                                                                  })
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("small", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  msg.type ==
                                                                    "2"
                                                                    ? " (auto)"
                                                                    : ""
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("small", [
                                                      _vm._v(
                                                        _vm._s(msg.agentName) +
                                                          " • " +
                                                          _vm._s(msg.date)
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-flex", {
                                                  staticClass:
                                                    "hidden-sm-and-down",
                                                  attrs: { md3: "" }
                                                })
                                              ],
                                              1
                                            )
                                          : _c(
                                              "v-layout",
                                              { attrs: { row: "" } },
                                              [
                                                _c("v-flex", {
                                                  staticClass:
                                                    "hidden-sm-and-down",
                                                  attrs: { md3: "" }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    staticClass:
                                                      "text-xs-right",
                                                    attrs: { xs10: "", md8: "" }
                                                  },
                                                  [
                                                    _c(
                                                      "v-card",
                                                      {
                                                        class: [
                                                          "white--text",
                                                          "histo__bubble",
                                                          "histo__bubble--visitor",
                                                          _vm.colorChatVisiteur
                                                        ]
                                                      },
                                                      [
                                                        _c(
                                                          "v-card-text",
                                                          {
                                                            staticClass:
                                                              "text-xs-right pa-1"
                                                          },
                                                          [
                                                            false
                                                              ? _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "corner corner--visitor",
                                                                    attrs: {
                                                                      color:
                                                                        _vm.colorChatVisiteur,
                                                                      unselectable:
                                                                        "on",
                                                                      onselectstart:
                                                                        "return false;",
                                                                      onmousedown:
                                                                        "return false;"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "arrow_drop_down"
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c("div", [
                                                              msg.text
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        msg.text
                                                                      )
                                                                    )
                                                                  ])
                                                                : _c("img", {
                                                                    attrs: {
                                                                      src:
                                                                        msg.attachment,
                                                                      alt:
                                                                        "Image indisponible"
                                                                    }
                                                                  })
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("small", [
                                                      _vm._v(_vm._s(msg.date))
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs2: "" } },
                                                  [
                                                    _c("wz-avatar", {
                                                      attrs: {
                                                        username:
                                                          "#" +
                                                          _vm.visitorSelected,
                                                        size: "35px"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                      ],
                                      1
                                    )
                                  }),
                                  _vm._v(" "),
                                  _vm.chatSelected.closed
                                    ? _c(
                                        "v-layout",
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "text-xs-center",
                                              attrs: { xs12: "" }
                                            },
                                            [
                                              _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    label: "",
                                                    disabled: "",
                                                    color: "secondary",
                                                    "text-color": "white"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t("closing")
                                                      ) +
                                                      " : " +
                                                      _vm._s(
                                                        _vm.chatSelected.closed
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        right: "",
                                                        dark: ""
                                                      }
                                                    },
                                                    [_vm._v("offline_pin")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "v-alert",
                        {
                          attrs: {
                            color: "blue",
                            icon: "info",
                            value: "true",
                            outline: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("cap")(_vm.$tc("chats", 0))) +
                              "\n          "
                          )
                        ]
                      )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88dd84a4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88dd84a4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzHistoBot.vue
// module id = null
// module chunks = 